import React, {useState,useEffect,useContext} from "react";
import { useForm } from 'react-hook-form';
import { useNavigate  } from 'react-router-dom';
import Context from '../context/context';
import Lang from '../lang/translations';
import Auth from '../../userServices/authServices';
import helpers from "../_helpers/helpersFunction";
const config = require("../_helpers/configServizi");


export default function ContactUs(props) {
	
	 

	
    const domain = window.location.hostname;
    const url_logo = config.servizi[domain].logo_su_chiaro;

    const [step, setStep] = useState(1);
  const [status, setStatus] = useState("idle"); 

  const [data, setData] = useState({
    topic: "",
    question: "",
    detail: "",
    name: "",
    surname: "",
    email: "",

    // SOLO PAGAMENTI
    transactionDate: "",
    amount: "",
    cardLast4: "",
    cardExpiry: "",
    });

    const isPaymentsFlow = data.topic === "pagamenti";

  const topics = [
    { value: "profilo", label: "Domande relative al tuo Profilo" },
    { value: "premium", label: "Domande relative alle funzionalità Premium", jump_to_form: true },
    { value: "pagamenti", label: "Segnalare problemi con Pagamenti" },
    { value: "tecnico", label: "Segnalare un problema tecnico" },
    { value: "sicurezza", label: "Segnalare un problema di Sicurezza/Privacy" },
  ];

  const questionsMap = {
    profilo: [
      "Non riesco ad accedere all'account",
      "Non riesco a recuperare la password",
      "Non riesco a verificare la mia e-Mail",
      "Non riesco a registrarmi",
      "Non riesco a cancellarmi",
    ],
    pagamenti: [
      "Non riesco a concludere il pagamento",
      "Ho pagato ma non ho ricevuto nulla",
      "Ho trovato dei pagamenti che non ricordo",
      "Non riesco a disabbonarmi",
      "Vorrei chiedere un rimborso",
    ],
    tecnico: [
      "Profili registrati",
      "Funzionalità del servizio",
      "Messaggi",
      "Profilo e foto",
      "Impostazioni",
      "Notifiche",
    ],
    sicurezza: [
      "Qualcuno sta usando le mie foto",
      "Qualcuno finge di essere me",
      "Impersonificazione",
      "Privacy e accesso ai dati",
    ],
  };

  const handleChange = (field) => (e) => {
    setData({ ...data, [field]: e.target.value });
  };

  const canGoNext =
    (step === 1 && data.topic) ||
    (step === 2 && data.question);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
        // SIMULAZIONE INVIO (sostituisci con fetch reale)
        
        setStatus("success");
        setStep(4);
    } catch (err) {
        setStatus("error");
        setStep(4);
    }
    };


    const handleTopicChange = (e) => {
        const selectedValue = e.target.value;
        const selectedTopic = topics.find(t => t.value === selectedValue);
        
        setData({ ...data, topic: selectedValue });
        
        // Salta direttamente allo step 3 se jump_to_form è true
        if (selectedTopic?.jump_to_form) {
            setStep(3);
        }
    };


    const nextStep = () => {
        // se è pagamenti, inserisce uno step in più
        if (step === 3 && isPaymentsFlow) {
            setStep(4);
        } else {
            setStep(step + 1);
        }
        };

        const prevStep = () => {
        if (step === 4 && isPaymentsFlow) {
            setStep(3);
        } else {
            setStep(step - 1);
        }
    };

	
    return (
		<div className="all-container bg-ligh personal-container">
			<div className="container filters-no-padding" role="main">
				<div className="align-center" style={{ margin: "1rem" }}>
                    <img width={120} src={url_logo} className="img-fluid logo" />
                </div>
                 
                        <div className="row">
                            <div className="md-12">
                                <h4><Lang w={"contattaci"} page={"contactUs"}/></h4>
                                <p><Lang w={"per_ricevere"} page={"contactUs"}/></p>
                            </div>
                           
                        </div>
                         <form id="form_contatti" onSubmit={handleSubmit}>
                            <div className="form-wrapper">
                                <div className="progress">
                                Step {step} di 3
                                </div>

                                {step === 1 && (
                                <section>
                                    <h2>Di cosa hai bisogno?</h2>
                                    <select value={data.topic} onChange={handleTopicChange} required>
                                        <option value="">Seleziona un argomento *</option>
                                        {topics.map((t) => (
                                            <option key={t.value} value={t.value}>
                                            {t.label}
                                            </option>
                                        ))}
                                    </select>
                                </section>
                                )}

                                {step === 2 && (
                                <section>
                                    <h2>Scegli una voce</h2>
                                    <div className="radio-group">
                                    {questionsMap[data.topic]?.map((q) => (
                                        <label key={q} className="radio-card">
                                        <input
                                            type="radio"
                                            name="question"
                                            value={q}
                                            checked={data.question === q}
                                            onChange={handleChange("question")}
                                        />
                                        <span className="radio-label">{q}</span>
                                        </label>
                                    ))}
                                    </div>
                                </section>
                                )}

                                {step === 3 && (
                                <section>
                                    <h2>Contattaci</h2>

                                    <textarea
                                    placeholder="Spiegaci meglio il problema *"
                                    value={data.detail}
                                    onChange={handleChange("detail")}
                                    required
                                    />

                                    <div className="grid">
                                    <input
                                        type="text"
                                        placeholder="Nome *"
                                        value={data.name}
                                        onChange={handleChange("name")}
                                        required
                                    />
                                    <input
                                        type="text"
                                        placeholder="Cognome *"
                                        value={data.surname}
                                        onChange={handleChange("surname")}
                                        required
                                    />
                                    </div>

                                    <input
                                    type="email"
                                    placeholder="Email *"
                                    value={data.email}
                                    onChange={handleChange("email")}
                                    required
                                    />
                                </section>
                                )}


                                {step === 3 && isPaymentsFlow && (
                                <section>
                                    <h2>Dettagli del pagamento</h2>

                                    <p className="hint">
                                    Questi dati non sono obbligatori, ma ci aiutano a gestire meglio la tua richiesta.
                                    </p>

                                    <label>
                                    Data della transazione
                                    <input
                                        type="date"
                                        value={data.transactionDate}
                                        onChange={handleChange("transactionDate")}
                                    />
                                    </label>

                                    <label className="inline">
                                    Importo della transazione
                                    <div className="amount">
                                        <input
                                        type="number"
                                        step="0.01"
                                        placeholder="9.99"
                                        value={data.amount}
                                        onChange={handleChange("amount")}
                                        />
                                        <span>EUR</span>
                                    </div>
                                    </label>

                                    <label>
                                    Ultime 4 cifre carta
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength="4"
                                        placeholder="1234"
                                        value={data.cardLast4}
                                        onChange={handleChange("cardLast4")}
                                    />
                                    </label>

                                    <label>
                                    Data di scadenza
                                    <input
                                        type="month"
                                        value={data.cardExpiry}
                                        onChange={handleChange("cardExpiry")}
                                    />
                                    </label>
                                </section>
                                )}

                               {((step === 3 && !isPaymentsFlow) || (step === 4 && isPaymentsFlow)) && (
                                <section>
                                    <h2>Contattaci</h2>

                                    <textarea
                                    placeholder="Spiegaci meglio il problema *"
                                    value={data.detail}
                                    onChange={handleChange("detail")}
                                    required
                                    />

                                    <div className="grid">
                                    <input
                                        type="text"
                                        placeholder="Nome *"
                                        value={data.name}
                                        onChange={handleChange("name")}
                                        required
                                    />
                                    <input
                                        type="text"
                                        placeholder="Cognome *"
                                        value={data.surname}
                                        onChange={handleChange("surname")}
                                        required
                                    />
                                    </div>

                                    <input
                                    type="email"
                                    placeholder="Email *"
                                    value={data.email}
                                    onChange={handleChange("email")}
                                    required
                                    />
                                </section>
                                )}

                                <div className="actions">
                                    {step > 1 && (
                                        <button type="button" className="secondary" onClick={prevStep}>
                                        Indietro
                                        </button>
                                    )}

                                    {(step < (isPaymentsFlow ? 4 : 3)) && (
                                        <button type="button" onClick={nextStep}>
                                        Avanti
                                        </button>
                                    )}

                                    {((step === 3 && !isPaymentsFlow) || (step === 4 && isPaymentsFlow)) && (
                                        <button type="submit">
                                        Invia richiesta
                                        </button>
                                    )}
                                </div>
                            </div>
                            </form>
                  
			</div>
		</div>
	);
}